export const defaultTheme = {
  palette: {
    common: {
      white: '#FFFFFF',
      black: '#000000',
    },
    primary: {
      main: '#1890ff',
      fontColor: '#000000',
    },
    secondary: {
      main: '#40a9ff',
      fontColor: '#000000',
    },
    background: '#e3e3e3',
    border: '#d3d3d3',
    scrollBar: '#a3a3a3',
  },
  font: {
    family: '"Noto Sans", sans-serif',
    style: 'normal',
    size: '10px',
    color: {
      description: '#00000080',
    },
  },
  borderRadius: {
    normal: '8px',
    large: '16px',
  },
};
